let i;
(function(e) {
  e.FirstName = "firstName", e.LastName = "lastName", e.Country = "country", e.City = "city", e.PostalCode = "zip", e.Zone = "province", e.Address1 = "address1", e.Address2 = "address2", e.Phone = "phone", e.Company = "company";
})(i || (i = {}));
const l = "https://atlas.shopifysvc.com/graphql";
let u;
(function(e) {
  e.Countries = "countries", e.Country = "country";
})(u || (u = {}));
const m = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*"
}, M = `
query countries($locale: SupportedLocale!) {
  countries(locale: $locale) {
    name
    code
    continent
    phoneNumberPrefix
    autocompletionField
    provinceKey
    labels {
      address1
      address2
      city
      company
      country
      firstName
      lastName
      phone
      postalCode
      zone
    }
    optionalLabels {
      address2
    }
    formatting {
      edit
      show
    }
    zones {
      name
      code
    }
  }
}

query country($countryCode: SupportedCountry!, $locale: SupportedLocale!) {
  country(countryCode: $countryCode, locale: $locale) {
    name
    code
    continent
    phoneNumberPrefix
    autocompletionField
    provinceKey
    labels {
      address1
      address2
      city
      company
      country
      firstName
      lastName
      phone
      postalCode
      zone
    }
    optionalLabels {
      address2
    }
    formatting {
      edit
      show
    }
    zones {
      name
      code
    }
  }
}
`;
var C = M;
const A = y(async (e, {
  includeHiddenZones: n = !1
} = {}) => {
  const a = await (await fetch(l, {
    method: "POST",
    headers: m,
    body: JSON.stringify({
      query: C,
      operationName: u.Countries,
      variables: {
        locale: e.replace(/-/, "_").toUpperCase(),
        includeHiddenZones: n
      }
    })
  })).json();
  if (!("data" in a) && "errors" in a)
    throw new S(a);
  return a.data.countries;
}), b = y(async (e, n, {
  includeHiddenZones: r = !1
} = {}) => {
  const o = await (await fetch(l, {
    method: "POST",
    headers: m,
    body: JSON.stringify({
      query: C,
      operationName: u.Country,
      variables: {
        countryCode: n,
        locale: e.replace(/-/, "_").toUpperCase(),
        includeHiddenZones: r
      }
    })
  })).json();
  if (!("data" in o) && "errors" in o)
    throw new S(o);
  return o.data.country;
});
class S extends Error {
  constructor(n) {
    const r = n.errors.map((a) => a.message).join("; ");
    super(r);
  }
}
function y(e) {
  const n = {};
  return (...r) => {
    const a = JSON.stringify(r);
    return n[a] || (n[a] = e.apply(this, r)), n[a];
  };
}
const h = /({\w+})/g, T = {
  "{firstName}": i.FirstName,
  "{lastName}": i.LastName,
  "{country}": i.Country,
  "{city}": i.City,
  "{zip}": i.PostalCode,
  "{province}": i.Zone,
  "{address1}": i.Address1,
  "{address2}": i.Address2,
  "{phone}": i.Phone,
  "{company}": i.Company
};
function B(e, n, r) {
  const a = n.match(h);
  let o = n;
  if (!a)
    return "";
  let t = !0;
  return a.forEach((d) => {
    const c = d.replace("{", "").replace("}", "");
    switch (r[c] && (t = !1), c) {
      case i.Country:
        o = o.replace(`{${i.Country}}`, e.name);
        break;
      case i.Zone:
        o = o.replace(`{${i.Zone}}`, r.province ? G(e.zones, r.province).name : "");
        break;
      default:
        o = o.replace(d, r[c] || "");
        break;
    }
  }), t ? "" : o.trim().replace("  ", " ");
}
function G(e, n) {
  return e.find((r) => r.code === n) || {
    name: "",
    code: ""
  };
}
const p = "_", I = "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}", L = "{lastName} {firstName}_{company}_{address1} {address2}_{city} {province} {zip}_{country}_{phone}";
function N(e, n) {
  return (n.formatting.show || L).split(p).map((a) => B(n, a, e).trim());
}
function P(e) {
  return (e ? e.formatting.edit : I).split(p).map((r) => {
    const a = r.match(h);
    return a ? a.map((o) => T[o]) : [];
  });
}
const s = /* @__PURE__ */ new Map();
class f {
  /**
   * Useful in tests or any situation where the cache has undesirable
   * side-effects.
   */
  static resetCache() {
    s.clear();
  }
  constructor(n) {
    this.locale = n, this.locale = n;
  }
  updateLocale(n) {
    this.locale = n;
  }
  async getCountry(n, {
    includeHiddenZones: r = !1
  } = {}) {
    const a = this.loadCountryFromCache(n, r);
    return a || b(this.locale, n, {
      includeHiddenZones: r
    });
  }
  async getCountries({
    includeHiddenZones: n = !1
  } = {}) {
    const r = this.cacheKey(this.locale, n), a = s.get(r);
    if (a) return a;
    const o = await A(this.locale, {
      includeHiddenZones: n
    });
    return s.set(r, o), o;
  }
  async getZoneName(n, r) {
    const o = (await this.getCountry(n)).zones.find((t) => t.code === r);
    if (o != null && o.name)
      return o.name;
  }
  /* Returns the address ordered in an array based based on the country code
   * Eg.:
   *   [
   *     'Shopify',
   *     'First Name Last Name',
   *     'Address 1',
   *     'address2',
   *     'Montréal',
   *     'Canada Quebec H2J 4B7',
   *     '514 444 3333'
   *   ]
   */
  async format(n) {
    const r = await this.getCountry(n.country);
    return N(n, r);
  }
  /* Returns an array that shows how to order fields based on the country code
   * Eg.:
   *   [
   *     ['company'],
   *     ['firstName', 'lastName'],
   *     ['address1'],
   *     ['address2'],
   *     ['city'],
   *     ['country', 'province', 'zip'],
   *     ['phone']
   *   ]
   */
  async getOrderedFields(n) {
    const r = await this.getCountry(n);
    return P(r);
  }
  cacheKey(n, r) {
    return `${n}-${r}`;
  }
  loadCountryFromCache(n, r) {
    const a = s.get(this.cacheKey(this.locale, r));
    return a ? a.find(({
      code: o
    }) => o === n) : null;
  }
}
const g = [
  {
    code: "AF",
    fr: "Afghanistan",
    en: "Afghanistan"
  },
  {
    code: "ZA",
    fr: "Afrique du Sud",
    en: "South Africa"
  },
  {
    code: "AX",
    fr: "Îles Åland",
    en: "Åland Islands"
  },
  {
    code: "AL",
    fr: "Albanie",
    en: "Albania"
  },
  {
    code: "DZ",
    fr: "Algérie",
    en: "Algeria"
  },
  {
    code: "DE",
    fr: "Allemagne",
    en: "Germany"
  },
  {
    code: "AD",
    fr: "Andorre",
    en: "Andorra"
  },
  {
    code: "AO",
    fr: "Angola",
    en: "Angola"
  },
  {
    code: "AI",
    fr: "Anguilla",
    en: "Anguilla"
  },
  {
    code: "AQ",
    fr: "Antarctique",
    en: "Antarctica"
  },
  {
    code: "AG",
    fr: "Antigua-et-Barbuda",
    en: "Antigua and Barbuda"
  },
  {
    code: "SA",
    fr: "Arabie saoudite",
    en: "Saudi Arabia"
  },
  {
    code: "AR",
    fr: "Argentine",
    en: "Argentina"
  },
  {
    code: "AM",
    fr: "Arménie",
    en: "Armenia"
  },
  {
    code: "AW",
    fr: "Aruba",
    en: "Aruba"
  },
  {
    code: "AU",
    fr: "Australie",
    en: "Australia"
  },
  {
    code: "AT",
    fr: "Autriche",
    en: "Austria"
  },
  {
    code: "AZ",
    fr: "Azerbaïdjan",
    en: "Azerbaijan"
  },
  {
    code: "BS",
    fr: "Bahamas",
    en: "Bahamas"
  },
  {
    code: "BH",
    fr: "Bahreïn",
    en: "Bahrain"
  },
  {
    code: "BD",
    fr: "Bangladesh",
    en: "Bangladesh"
  },
  {
    code: "BB",
    fr: "Barbade",
    en: "Barbados"
  },
  {
    code: "BY",
    fr: "Biélorussie",
    en: "Belarus"
  },
  {
    code: "BE",
    fr: "Belgique",
    en: "Belgium"
  },
  {
    code: "BZ",
    fr: "Belize",
    en: "Belize"
  },
  {
    code: "BJ",
    fr: "Bénin",
    en: "Benin"
  },
  {
    code: "BM",
    fr: "Bermudes",
    en: "Bermuda"
  },
  {
    code: "BT",
    fr: "Bhoutan",
    en: "Bhutan"
  },
  {
    code: "BO",
    fr: "Bolivie",
    en: "Bolivia (Plurinational State of)"
  },
  {
    code: "BQ",
    fr: "Bonaire",
    en: "Bonaire"
  },
  {
    code: "BA",
    fr: "Bosnie-Herzégovine",
    en: "Bosnia and Herzegovina"
  },
  {
    code: "BW",
    fr: "Botswana",
    en: "Botswana"
  },
  {
    code: "BV",
    fr: "Île Bouvet",
    en: "Bouvet Island"
  },
  {
    code: "BR",
    fr: "Brésil",
    en: "Brazil"
  },
  {
    code: "BN",
    fr: "Brunei",
    en: "Brunei Darussalam"
  },
  {
    code: "BG",
    fr: "Bulgarie",
    en: "Bulgaria"
  },
  {
    code: "BF",
    fr: "Burkina Faso",
    en: "Burkina Faso"
  },
  {
    code: "BI",
    fr: "Burundi",
    en: "Burundi"
  },
  {
    code: "KY",
    fr: "Îles Caïmans",
    en: "Cayman Islands"
  },
  {
    code: "KH",
    fr: "Cambodge",
    en: "Cambodia"
  },
  {
    code: "CM",
    fr: "Cameroun",
    en: "Cameroon"
  },
  {
    code: "CA",
    fr: "Canada",
    en: "Canada"
  },
  {
    code: "CV",
    fr: "Cap-Vert",
    en: "Cabo Verde"
  },
  {
    code: "CF",
    fr: "République centrafricaine",
    en: "Central African Republic"
  },
  {
    code: "CL",
    fr: "Chili",
    en: "Chile"
  },
  {
    code: "CN",
    fr: "Chine",
    en: "China"
  },
  {
    code: "CX",
    fr: "Île Christmas",
    en: "Christmas Island"
  },
  {
    code: "CY",
    fr: "Chypre",
    en: "Cyprus"
  },
  {
    code: "CC",
    fr: "Îles Cocos",
    en: "Cocos (Keeling) Islands"
  },
  {
    code: "CO",
    fr: "Colombie",
    en: "Colombia"
  },
  {
    code: "KM",
    fr: "Comores",
    en: "Comoros"
  },
  {
    code: "CG",
    fr: "République du Congo",
    en: "Congo"
  },
  {
    code: "CD",
    fr: "République démocratique du Congo",
    en: "Congo, Democratic Republic of the"
  },
  {
    code: "CK",
    fr: "Îles Cook",
    en: "Cook Islands"
  },
  {
    code: "KR",
    fr: "Corée du Sud",
    en: "Korea, Republic of"
  },
  {
    code: "KP",
    fr: "Corée du Nord",
    en: "Korea (Democratic People's Republic of)"
  },
  {
    code: "CR",
    fr: "Costa Rica",
    en: "Costa Rica"
  },
  {
    code: "CI",
    fr: "Côte d'Ivoire",
    en: "Côte d'Ivoire"
  },
  {
    code: "HR",
    fr: "Croatie",
    en: "Croatia"
  },
  {
    code: "CU",
    fr: "Cuba",
    en: "Cuba"
  },
  {
    code: "CW",
    fr: "Curaçao",
    en: "Curaçao"
  },
  {
    code: "DK",
    fr: "Danemark",
    en: "Denmark"
  },
  {
    code: "DJ",
    fr: "Djibouti",
    en: "Djibouti"
  },
  {
    code: "DO",
    fr: "République dominicaine",
    en: "Dominican Republic"
  },
  {
    code: "DM",
    fr: "Dominique",
    en: "Dominica"
  },
  {
    code: "EG",
    fr: "Égypte",
    en: "Egypt"
  },
  {
    code: "SV",
    fr: "Salvador",
    en: "El Salvador"
  },
  {
    code: "AE",
    fr: "Émirats Arabes Unis",
    en: "United Arab Emirates"
  },
  {
    code: "EC",
    fr: "Équateur",
    en: "Ecuador"
  },
  {
    code: "ER",
    fr: "Érythrée",
    en: "Eritrea"
  },
  {
    code: "ES",
    fr: "Espagne",
    en: "Spain"
  },
  {
    code: "EE",
    fr: "Estonie",
    en: "Estonia"
  },
  {
    code: "US",
    fr: "États-Unis",
    en: "United States of America"
  },
  {
    code: "ET",
    fr: "Éthiopie",
    en: "Ethiopia"
  },
  {
    code: "FK",
    fr: "Îles Malouines",
    en: "Falkland Islands (Malvinas)"
  },
  {
    code: "FO",
    fr: "Îles Féroé",
    en: "Faroe Islands"
  },
  {
    code: "FJ",
    fr: "Fidji",
    en: "Fiji"
  },
  {
    code: "FI",
    fr: "Finlande",
    en: "Finland"
  },
  {
    code: "FR",
    fr: "France",
    en: "France"
  },
  {
    code: "GA",
    fr: "Gabon",
    en: "Gabon"
  },
  {
    code: "GM",
    fr: "Gambie",
    en: "Gambia"
  },
  {
    code: "GE",
    fr: "Géorgie",
    en: "Georgia"
  },
  {
    code: "GS",
    fr: "Géorgie du Sud-et-les îles Sandwich du Sud",
    en: "South Georgia and the South Sandwich Islands"
  },
  {
    code: "GH",
    fr: "Ghana",
    en: "Ghana"
  },
  {
    code: "GI",
    fr: "Gibraltar",
    en: "Gibraltar"
  },
  {
    code: "GR",
    fr: "Grèce",
    en: "Greece"
  },
  {
    code: "GD",
    fr: "Grenade",
    en: "Grenada"
  },
  {
    code: "GL",
    fr: "Groenland",
    en: "Greenland"
  },
  {
    code: "GP",
    fr: "Guadeloupe",
    en: "Guadeloupe"
  },
  {
    code: "GU",
    fr: "Guam",
    en: "Guam"
  },
  {
    code: "GT",
    fr: "Guatemala",
    en: "Guatemala"
  },
  {
    code: "GG",
    fr: "Guernesey",
    en: "Guernsey"
  },
  {
    code: "GN",
    fr: "Guinée",
    en: "Guinea"
  },
  {
    code: "GW",
    fr: "Guinée-Bissau",
    en: "Guinea-Bissau"
  },
  {
    code: "GQ",
    fr: "Guinée équatoriale",
    en: "Equatorial Guinea"
  },
  {
    code: "GY",
    fr: "Guyana",
    en: "Guyana"
  },
  {
    code: "GF",
    fr: "Guyane",
    en: "French Guiana"
  },
  {
    code: "HT",
    fr: "Haïti",
    en: "Haiti"
  },
  {
    code: "HM",
    fr: "Îles Heard-et-MacDonald",
    en: "Heard Island and McDonald Islands"
  },
  {
    code: "HN",
    fr: "Honduras",
    en: "Honduras"
  },
  {
    code: "HK",
    fr: "Hong Kong",
    en: "Hong Kong"
  },
  {
    code: "HU",
    fr: "Hongrie",
    en: "Hungary"
  },
  {
    code: "IM",
    fr: "Île de Man",
    en: "Isle of Man"
  },
  {
    code: "UM",
    fr: "Îles mineures éloignées des États-Unis",
    en: "United States Minor Outlying Islands"
  },
  {
    code: "VG",
    fr: "Îles Vierges britanniques",
    en: "Virgin Islands (British)"
  },
  {
    code: "VI",
    fr: "Îles Vierges des États-Unis",
    en: "Virgin Islands (U.S.)"
  },
  {
    code: "IN",
    fr: "Inde",
    en: "India"
  },
  {
    code: "ID",
    fr: "Indonésie",
    en: "Indonesia"
  },
  {
    code: "IR",
    fr: "Iran",
    en: "Iran (Islamic Republic of)"
  },
  {
    code: "IQ",
    fr: "Irak",
    en: "Iraq"
  },
  {
    code: "IE",
    fr: "Irlande",
    en: "Ireland"
  },
  {
    code: "IS",
    fr: "Islande",
    en: "Iceland"
  },
  {
    code: "IL",
    fr: "Israël",
    en: "Israel"
  },
  {
    code: "IT",
    fr: "Italie",
    en: "Italy"
  },
  {
    code: "JM",
    fr: "Jamaïque",
    en: "Jamaica"
  },
  {
    code: "JP",
    fr: "Japon",
    en: "Japan"
  },
  {
    code: "JE",
    fr: "Jersey",
    en: "Jersey"
  },
  {
    code: "JO",
    fr: "Jordanie",
    en: "Jordan"
  },
  {
    code: "KZ",
    fr: "Kazakhstan",
    en: "Kazakhstan"
  },
  {
    code: "KE",
    fr: "Kenya",
    en: "Kenya"
  },
  {
    code: "KG",
    fr: "Kirghizistan",
    en: "Kyrgyzstan"
  },
  {
    code: "KI",
    fr: "Kiribati",
    en: "Kiribati"
  },
  {
    code: "KW",
    fr: "Koweït",
    en: "Kuwait"
  },
  {
    code: "LA",
    fr: "Laos",
    en: "Lao People's Democratic Republic"
  },
  {
    code: "LS",
    fr: "Lesotho",
    en: "Lesotho"
  },
  {
    code: "LV",
    fr: "Lettonie",
    en: "Latvia"
  },
  {
    code: "LB",
    fr: "Liban",
    en: "Lebanon"
  },
  {
    code: "LR",
    fr: "Libéria",
    en: "Liberia"
  },
  {
    code: "LY",
    fr: "Libye",
    en: "Libya"
  },
  {
    code: "LI",
    fr: "Liechtenstein",
    en: "Liechtenstein"
  },
  {
    code: "LT",
    fr: "Lituanie",
    en: "Lithuania"
  },
  {
    code: "LU",
    fr: "Luxembourg",
    en: "Luxembourg"
  },
  {
    code: "MO",
    fr: "Macao",
    en: "Macao"
  },
  {
    code: "MK",
    fr: "République de Macédoine",
    en: "Macedonia, the former Yugoslav Republic of"
  },
  {
    code: "MG",
    fr: "Madagascar",
    en: "Madagascar"
  },
  {
    code: "MY",
    fr: "Malaisie",
    en: "Malaysia"
  },
  {
    code: "MW",
    fr: "Malawi",
    en: "Malawi"
  },
  {
    code: "MV",
    fr: "Maldives",
    en: "Maldives"
  },
  {
    code: "ML",
    fr: "Mali",
    en: "Mali"
  },
  {
    code: "MT",
    fr: "Malte",
    en: "Malta"
  },
  {
    code: "MP",
    fr: "Îles Mariannes du Nord",
    en: "Northern Mariana Islands"
  },
  {
    code: "MA",
    fr: "Maroc",
    en: "Morocco"
  },
  {
    code: "MH",
    fr: "Îles Marshall",
    en: "Marshall Islands"
  },
  {
    code: "MQ",
    fr: "Martinique",
    en: "Martinique"
  },
  {
    code: "MU",
    fr: "Maurice",
    en: "Mauritius"
  },
  {
    code: "MR",
    fr: "Mauritanie",
    en: "Mauritania"
  },
  {
    code: "YT",
    fr: "Mayotte",
    en: "Mayotte"
  },
  {
    code: "MX",
    fr: "Mexique",
    en: "Mexico"
  },
  {
    code: "FM",
    fr: "États Fédérés de Micronésie",
    en: "Micronesia (Federated States of)"
  },
  {
    code: "MD",
    fr: "Moldavie",
    en: "Moldova, Republic of"
  },
  {
    code: "MC",
    fr: "Monaco",
    en: "Monaco"
  },
  {
    code: "MN",
    fr: "Mongolie",
    en: "Mongolia"
  },
  {
    code: "ME",
    fr: "Monténégro",
    en: "Montenegro"
  },
  {
    code: "MS",
    fr: "Montserrat",
    en: "Montserrat"
  },
  {
    code: "MZ",
    fr: "Mozambique",
    en: "Mozambique"
  },
  {
    code: "MM",
    fr: "Myanmar",
    en: "Myanmar"
  },
  {
    code: "NA",
    fr: "Namibie",
    en: "Namibia"
  },
  {
    code: "NR",
    fr: "Nauru",
    en: "Nauru"
  },
  {
    code: "NP",
    fr: "Népal",
    en: "Nepal"
  },
  {
    code: "NI",
    fr: "Nicaragua",
    en: "Nicaragua"
  },
  {
    code: "NE",
    fr: "Niger",
    en: "Niger"
  },
  {
    code: "NG",
    fr: "Nigéria",
    en: "Nigeria"
  },
  {
    code: "NU",
    fr: "Niue",
    en: "Niue"
  },
  {
    code: "NF",
    fr: "Île Norfolk",
    en: "Norfolk Island"
  },
  {
    code: "NO",
    fr: "Norvège",
    en: "Norway"
  },
  {
    code: "NC",
    fr: "Nouvelle-Calédonie",
    en: "New Caledonia"
  },
  {
    code: "NZ",
    fr: "Nouvelle-Zélande",
    en: "New Zealand"
  },
  {
    code: "IO",
    fr: "Territoire Britannique de l'Océan Indien",
    en: "British Indian Ocean Territory"
  },
  {
    code: "OM",
    fr: "Oman",
    en: "Oman"
  },
  {
    code: "UG",
    fr: "Ouganda",
    en: "Uganda"
  },
  {
    code: "UZ",
    fr: "Ouzbékistan",
    en: "Uzbekistan"
  },
  {
    code: "PK",
    fr: "Pakistan",
    en: "Pakistan"
  },
  {
    code: "PW",
    fr: "Palaos",
    en: "Palau"
  },
  {
    code: "PS",
    fr: "Palestine",
    en: "Palestine, State of"
  },
  {
    code: "PA",
    fr: "Panama",
    en: "Panama"
  },
  {
    code: "PG",
    fr: "Papouasie-Nouvelle-Guinée",
    en: "Papua New Guinea"
  },
  {
    code: "PY",
    fr: "Paraguay",
    en: "Paraguay"
  },
  {
    code: "NL",
    fr: "Pays-Bas",
    en: "Netherlands"
  },
  {
    code: "PE",
    fr: "Pérou",
    en: "Peru"
  },
  {
    code: "PH",
    fr: "Philippines",
    en: "Philippines"
  },
  {
    code: "PN",
    fr: "Îles Pitcairn",
    en: "Pitcairn"
  },
  {
    code: "PL",
    fr: "Pologne",
    en: "Poland"
  },
  {
    code: "PF",
    fr: "Polynésie française",
    en: "French Polynesia"
  },
  {
    code: "PR",
    fr: "Porto Rico",
    en: "Puerto Rico"
  },
  {
    code: "PT",
    fr: "Portugal",
    en: "Portugal"
  },
  {
    code: "QA",
    fr: "Qatar",
    en: "Qatar"
  },
  {
    code: "RE",
    fr: "La Réunion",
    en: "Réunion"
  },
  {
    code: "RO",
    fr: "Roumanie",
    en: "Romania"
  },
  {
    code: "GB",
    fr: "Royaume-Uni",
    en: "United Kingdom"
  },
  {
    code: "RU",
    fr: "Russie",
    en: "Russian Federation"
  },
  {
    code: "RW",
    fr: "Rwanda",
    en: "Rwanda"
  },
  {
    code: "EH",
    fr: "République arabe sahraouie démocratique",
    en: "Western Sahara"
  },
  {
    code: "BL",
    fr: "Saint-Barthélemy",
    en: "Saint Barthélemy"
  },
  {
    code: "KN",
    fr: "Saint-Christophe-et-Niévès",
    en: "Saint Kitts and Nevis"
  },
  {
    code: "SM",
    fr: "Saint-Marin",
    en: "San Marino"
  },
  {
    code: "MF",
    fr: "Saint-Martin (Antilles françaises)",
    en: "Saint Martin (French part)"
  },
  {
    code: "SX",
    fr: "Saint-Martin (royaume des Pays-Bas)",
    en: "Sint Maarten (Dutch part)"
  },
  {
    code: "PM",
    fr: "Saint-Pierre-et-Miquelon",
    en: "Saint Pierre and Miquelon"
  },
  {
    code: "VA",
    fr: "Saint-Siège (État de la Cité du Vatican)",
    en: "Holy See"
  },
  {
    code: "VC",
    fr: "Saint-Vincent-et-les-Grenadines",
    en: "Saint Vincent and the Grenadines"
  },
  {
    code: "SH",
    fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
    en: "Saint Helena, Ascension and Tristan da Cunha"
  },
  {
    code: "LC",
    fr: "Sainte-Lucie",
    en: "Saint Lucia"
  },
  {
    code: "SB",
    fr: "Salomon",
    en: "Solomon Islands"
  },
  {
    code: "WS",
    fr: "Samoa",
    en: "Samoa"
  },
  {
    code: "AS",
    fr: "Samoa américaines",
    en: "American Samoa"
  },
  {
    code: "ST",
    fr: "Sao Tomé-et-Principe",
    en: "Sao Tome and Principe"
  },
  {
    code: "SN",
    fr: "Sénégal",
    en: "Senegal"
  },
  {
    code: "RS",
    fr: "Serbie",
    en: "Serbia"
  },
  {
    code: "SC",
    fr: "Seychelles",
    en: "Seychelles"
  },
  {
    code: "SL",
    fr: "Sierra Leone",
    en: "Sierra Leone"
  },
  {
    code: "SG",
    fr: "Singapour",
    en: "Singapore"
  },
  {
    code: "SK",
    fr: "Slovaquie",
    en: "Slovakia"
  },
  {
    code: "SI",
    fr: "Slovénie",
    en: "Slovenia"
  },
  {
    code: "SO",
    fr: "Somalie",
    en: "Somalia"
  },
  {
    code: "SD",
    fr: "Soudan",
    en: "Sudan"
  },
  {
    code: "SS",
    fr: "Soudan du Sud",
    en: "South Sudan"
  },
  {
    code: "LK",
    fr: "Sri Lanka",
    en: "Sri Lanka"
  },
  {
    code: "SE",
    fr: "Suède",
    en: "Sweden"
  },
  {
    code: "CH",
    fr: "Suisse",
    en: "Switzerland"
  },
  {
    code: "SR",
    fr: "Suriname",
    en: "Suriname"
  },
  {
    code: "SJ",
    fr: "Svalbard et île Jan Mayen",
    en: "Svalbard and Jan Mayen"
  },
  {
    code: "SZ",
    fr: "Swaziland",
    en: "Eswatini"
  },
  {
    code: "SY",
    fr: "Syrie",
    en: "Syrian Arab Republic"
  },
  {
    code: "TJ",
    fr: "Tadjikistan",
    en: "Tajikistan"
  },
  {
    code: "TW",
    fr: "Taïwan",
    en: "Taiwan, Province of China"
  },
  {
    code: "TZ",
    fr: "Tanzanie",
    en: "Tanzania, United Republic of"
  },
  {
    code: "TD",
    fr: "Tchad",
    en: "Chad"
  },
  {
    code: "CZ",
    fr: "Tchéquie",
    en: "Czechia"
  },
  {
    code: "TF",
    fr: "Terres australes et antarctiques françaises",
    en: "French Southern Territories"
  },
  {
    code: "TH",
    fr: "Thaïlande",
    en: "Thailand"
  },
  {
    code: "TL",
    fr: "Timor oriental",
    en: "Timor-Leste"
  },
  {
    code: "TG",
    fr: "Togo",
    en: "Togo"
  },
  {
    code: "TK",
    fr: "Tokelau",
    en: "Tokelau"
  },
  {
    code: "TO",
    fr: "Tonga",
    en: "Tonga"
  },
  {
    code: "TT",
    fr: "Trinité-et-Tobago",
    en: "Trinidad and Tobago"
  },
  {
    code: "TN",
    fr: "Tunisie",
    en: "Tunisia"
  },
  {
    code: "TM",
    fr: "Turkménistan",
    en: "Turkmenistan"
  },
  {
    code: "TC",
    fr: "Îles Turques-et-Caïques",
    en: "Turks and Caicos Islands"
  },
  {
    code: "TR",
    fr: "Turquie",
    en: "Turkey"
  },
  {
    code: "TV",
    fr: "Tuvalu",
    en: "Tuvalu"
  },
  {
    code: "UA",
    fr: "Ukraine",
    en: "Ukraine"
  },
  {
    code: "UY",
    fr: "Uruguay",
    en: "Uruguay"
  },
  {
    code: "VU",
    fr: "Vanuatu",
    en: "Vanuatu"
  },
  {
    code: "VE",
    fr: "Venezuela",
    en: "Venezuela (Bolivarian Republic of)"
  },
  {
    code: "VN",
    fr: "Viêt Nam",
    en: "Viet Nam"
  },
  {
    code: "WF",
    fr: "Wallis-et-Futuna",
    en: "Wallis and Futuna"
  },
  {
    code: "YE",
    fr: "Yémen",
    en: "Yemen"
  },
  {
    code: "ZM",
    fr: "Zambie",
    en: "Zambia"
  },
  {
    code: "ZW",
    fr: "Zimbabwe",
    en: "Zimbabwe"
  }
], F = async (e, n) => {
  let a = await new f("FR").getOrderedFields(e);
  return [...n, i.Country].forEach((o) => {
    a.forEach((t) => {
      const d = t.findIndex(
        (c) => c.includes(o)
      );
      d !== -1 && t.splice(d, 1);
    });
  }), a = a.filter(
    (o) => o.length > 0
  ), a.unshift([i.Country]), a;
}, R = (e) => [
  [i.Country],
  [i.Company],
  [i.FirstName, i.LastName],
  [i.Address1],
  [i.Address2],
  [i.PostalCode, i.City],
  [i.Phone]
].map(
  (a) => a.filter((o) => !e.includes(o))
).filter((a) => a.length > 0), E = (e) => g.find(
  (n) => n.code.trim().toLowerCase() === e.trim().toLowerCase()
), w = (e) => g.find(
  (n) => n.fr.trim().toLowerCase() === (e == null ? void 0 : e.trim().toLowerCase()) || n.en.trim().toLowerCase() === (e == null ? void 0 : e.trim().toLowerCase())
), v = (e, n) => new f(n).getCountry(e), D = (e) => new f(e).getCountries(), K = (e) => [
  e.company ?? "",
  e.address1,
  e.address2,
  `${e.zip} ${e.city}`,
  e.country
], q = async (e, n) => (await new f(n).format(e)).filter((o) => o !== "");
export {
  g as countries,
  K as defaultFormattedAddress,
  F as getAddressOrderedFields,
  D as getCountries,
  v as getCountry,
  E as getCountryFromCountryCode,
  w as getCountryFromCountryName,
  R as getDefaultFrenchAddressFields,
  q as getFormattedAddress
};
